import VueRouter from "vue-router"
import { Account } from "@/api"

import AnalysisItem from "@/pages/integrations/AnalysisItem"
import MultipleAncestriesItem from "@/pages/integrations/MultipleAncestriesItem"
import StatisticsItem from "@/pages/task/StatisticsItem"
import ReferenceItem from "@/pages/integrations/ReferenceItem"
import GWASSummaryStatistics from "@/pages/integrations/GWASSummaryStatistics"

import LoginItem from "@/pages/authentication/LoginItem"
import RegisterItem from "@/pages/authentication/RegisterItem"
import SettingsItem from "@/pages/authentication/SettingsItem"
import ResultItem from "@/pages/authentication/ResultItem"

import HomeItem from "@/pages/home"
import FunctionItem from "@/pages/function"
import TutorialItem from "@/components/commons/TutorialItem"
import AboutItem from "@/components/commons/AboutItem"
import DtaPage from "@/pages/dta/DtaPage.vue"

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        { path: "/", redirect: "/home" },

        // --- Public Routes ---
        { name: "home", path: "/home", component: HomeItem, meta: { public: true } },
        { name: "login", path: "/login", component: LoginItem, meta: { public: true, guestOnly: true } },
        { name: "register", path: "/register", component: RegisterItem, meta: { public: true, guestOnly: true } },
        { name: "result", path: "/result", component: ResultItem, meta: { public: true } },
        { name: "tutorial", path: "/tutorial", component: TutorialItem, meta: { public: true } },
        { name: "AboutItem", path: "/AboutItem", component: AboutItem, meta: { public: true } },
        { name: "DtaPage", path: "/dta", component: DtaPage, meta: { public: true } },

        // --- Protected Layout (The core analysis pipeline) ---
        {
            name: "functionItem",
            path: "/functionItem",
            component: FunctionItem,
            redirect: "/functionItem/analysis",
            meta: { requiresAuth: true },
            children: [
                {
                    name: "gwasreference",
                    path: "gwasreference",
                    component: GWASSummaryStatistics,
                    meta: { requiresAuth: true, step: 1 } // <--- Step 1
                },
                {
                    name: "ldreference",
                    path: "ldreference",
                    component: ReferenceItem,
                    meta: { requiresAuth: true, step: 2 }, // <--- Step 2
                    props() {
                        return { pageTitle: "LD References", type: "LD" }
                    },
                },
                {
                    name: "analysis",
                    path: "analysis",
                    component: AnalysisItem,
                    meta: { requiresAuth: true, step: 3 } // <--- Step 3
                },
                {
                    name: "multipleAncestries",
                    path: "multipleAncestries",
                    component: MultipleAncestriesItem,
                    meta: { requiresAuth: true, step: 3 } // <--- Step 3 (Same as analysis)
                },
                {
                    name: "statistics",
                    path: "statistics",
                    component: StatisticsItem,
                    meta: { requiresAuth: true, step: 4 } // <--- Step 4
                },
                {
                    name: "settings",
                    path: "settings",
                    component: SettingsItem,
                    meta: { requiresAuth: true }
                },
            ],
        },

        // --- Aliases to keep sidebar paths working ---
        // 注意：重定向会保留目标路由的 meta 信息，所以侧边栏能正确获取 step
        { path: "/analysis", redirect: "/functionItem/analysis" },
        { path: "/multipleAncestries", redirect: "/functionItem/multipleAncestries" },
        { path: "/statistics", redirect: "/functionItem/statistics" },
        { path: "/gwasreference", redirect: "/functionItem/gwasreference" },
        { path: "/ldreference", redirect: "/functionItem/ldreference" },
        { path: "/settings", redirect: "/functionItem/settings" },

        { path: "*", redirect: "/home" },
    ],
})

/**
 * 全局导航守卫
 */
// router.beforeEach((to, from, next) => {
//     const isAuthed = Account.isAuthenticated();

//     // 检查是否需要登录
//     const requiresAuth = to.matched.some(record => record.meta?.requiresAuth);
//     const isGuestOnly = to.matched.some(record => record.meta?.guestOnly);

//     // 1. 已登录用户禁止访问登录/注册页
//     if (isAuthed && isGuestOnly) {
//         return next({ path: '/home' });
//     }

//     // 2. 访问受限页面但未登录
//     if (requiresAuth && !isAuthed) {
//         console.warn("Access denied: Auth required for", to.path);
//         return next({
//             path: "/login",
//             query: { redirect: to.fullPath }
//         });
//     }

//     // 3. 正常放行
//     next();
// });

export default router